import { render, staticRenderFns } from "./FeedbackAnalytics.vue?vue&type=template&id=4c9f256f&"
import script from "./FeedbackAnalytics.vue?vue&type=script&lang=js&"
export * from "./FeedbackAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports